import { useEffect } from 'react';
import { pageview, set } from 'react-ga';
import { useHistory, useLocation } from 'react-router-dom';
import { auth } from './auth';
import { Role } from '@prismamedia/one-user';
import { paths } from 'routing';

export const useLocationChange = () => {
  const { pathname, search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (auth.isAuthenticated()) {
      if (
        auth.user.roles.some((role) => role.includes(Role.Cdf)) &&
        pathname !== paths.RAILROAD
      ) {
        history.push(paths.RAILROAD);
      }
      set({ userId: auth.user.id });
    }
    pageview(`${pathname}${search}`);
  }, [pathname, search, history]);
};
